// extracted by mini-css-extract-plugin
export default {"tooltip":"cT-z","arrow":"dT-z"};